
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_l26z3_3",
  "input": "awsui_input_2rhyz_l26z3_7",
  "input-readonly": "awsui_input-readonly_2rhyz_l26z3_27",
  "input-invalid": "awsui_input-invalid_2rhyz_l26z3_88",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_l26z3_99",
  "input-type-search": "awsui_input-type-search_2rhyz_l26z3_104",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_l26z3_120",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_l26z3_123",
  "input-container": "awsui_input-container_2rhyz_l26z3_127",
  "input-icon": "awsui_input-icon_2rhyz_l26z3_132",
  "input-icon-hoverable": "awsui_input-icon-hoverable_2rhyz_l26z3_135",
  "input-icon-left": "awsui_input-icon-left_2rhyz_l26z3_139",
  "input-icon-right": "awsui_input-icon-right_2rhyz_l26z3_144"
};
  